import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";

export default function Unauthorized() {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "var(--clr-bg)", textAlign: "center", padding: "0 24px" }}>
      <div style={{ background: "var(--clr-accent-bg)", width: 80, height: 80, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 24 }}>
        <ShieldOff size={40} color="var(--clr-accent)" />
      </div>
      <h1 style={{ fontSize: 64, fontWeight: 800, color: "var(--clr-text)", lineHeight: 1, marginBottom: 8 }}>403</h1>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: "var(--clr-text)", marginBottom: 12 }}>Acceso denegado</h2>
      <p style={{ color: "var(--clr-muted)", fontSize: 14, marginBottom: 28, maxWidth: 360 }}>
        No tienes permisos para acceder a esta sección.<br />
        Si crees que es un error, contacta con tu administrador.
      </p>
      <Link to="/" className="tn-btn tn-btn--primary tn-btn--lg">
        Volver al inicio
      </Link>
    </div>
  );
}
